export default __webpack_public_path__ + "static/benefitBg-35328a363223a328ccfb33eacca7733c.webp";